import { render, staticRenderFns } from "./OptionDropdownSelect.vue?vue&type=template&id=2f2ad81d&scoped=true"
import script from "./OptionDropdownSelect.vue?vue&type=script&lang=js"
export * from "./OptionDropdownSelect.vue?vue&type=script&lang=js"
import style0 from "./OptionDropdownSelect.vue?vue&type=style&index=0&id=2f2ad81d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ad81d",
  null
  
)

export default component.exports